import { render, staticRenderFns } from "./jobbag-icon.vue?vue&type=template&id=3a509c47"
import script from "./jobbag-icon.vue?vue&type=script&lang=js"
export * from "./jobbag-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports